import { BroadcastEventListener, IConnectionOptions, SignalR, SignalRConnection } from 'ng2-signalr';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApplicationStateManagerService } from '../../api/managers/application-state-manager.service';
import { Constants } from '../../core/constants';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-app-connectivity',
    templateUrl: './app-connectivity.component.html',
    styleUrls: ['./app-connectivity.component.less']
})
export class AppConnectivityComponent implements OnInit, OnDestroy {
    public isOnline = true;
    interval;
    lastUpdated = moment();
    private connection: SignalRConnection;
    constructor(public applicationStateManager: ApplicationStateManagerService,
        private route:ActivatedRoute) {

        }

    ngOnInit() {

        if (this.interval) { clearInterval(this.interval); }

    }

    ngOnDestroy() {
        clearInterval(this.interval);
    }

    public updateStatus(isOnline:boolean) {
        const now = moment();
            this.isOnline = isOnline;
    }
}
